import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';

import lozad from 'lozad';

import './js/components/gallery';
import './js/contact.js';
import functions from './js/functions.js'
import './js/globals.js';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/enterprise.js?render=" + functions.getRecaptchaKey());
    }
});
window.nobserver.observe();
